import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Afhalen',
        [ORDER_METHODS.DELIVERY]: 'Bezorging',
        [ORDER_METHODS.ON_SITE]: 'Bestellen aan tafel',
      },
    },
    delivery_info: {
      title: 'Bezorggegevens',
      on_arrival: 'Bij aankomst:',
    },
    customer_info: {
      title: 'Contact',
    },
    payment: {
      title: 'Betaling',
    },
    request_invoice: {
      title: 'Factuur aanvragen',
      form: {
        is_receipt_required: {
          label: 'Factuur aanvragen per e-mail',
        },
      },
    },
    location: {
      title: 'Winkeladres',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Bezorgadres',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Jouw tafel',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Afhaaladres',
      },
    },
    method: {
      title: 'Methode',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Bezorging',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Bestellen aan tafel',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Afhalen',
      },
    },
    time: {
      title: 'Tijd',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standaard {{time}} min, Vandaag',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Later inplannen',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Bel aan',
        [DropoffAction.Sms]: 'Neem bij aankomst contact met mij op via sms',
      },
    },
    doorbell_name: {
      placeholder: 'Naam deurbel (optioneel)',
    },
    company_name: {
      placeholder: 'Bedrijfsnaam (optioneel)',
    },
    customer_note: {
      placeholder: 'Heb je een opmerking voor het restaurant?',
    },
  },
  buttons: {
    change: 'Wijzigen',
    edit: 'Bewerken',
    done: 'Klaar',
    add_delivery_note: '+ Bezorggegevens toevoegen',
    add_order_note: '+ Bestelnotitie toevoegen',
  },
  summary: {
    doorbell: 'Deurbel',
    company: 'Bedrijf',
    note: 'Bestelnotitie',
  },
};
